// Assessment status (as stored by vo-api-vendor) → key under gap-analysis:assessment.list.statuses.
export const ASSESSMENT_STATUS_I18N_KEY = {
  'Draft':                      'draft',
  'Pending Vendor Response':    'pendingVendorResponse',
  'Submitted':                  'submitted',
  'Completed':                  'completed',
  'Under Review':               'underReview',
  'Pending Executive Approval': 'pendingExecutiveApproval',
  'Approved':                   'approved',
  'Rejected':                   'rejected',
  'Contractual Review':         'contractualReview',
};

export const assessmentStatusLabel = (t, status) =>
  ASSESSMENT_STATUS_I18N_KEY[status]
    ? t(`gap-analysis:assessment.list.statuses.${ASSESSMENT_STATUS_I18N_KEY[status]}`)
    : status;
